// Redux actions
export const FETCH_DETAIL_PAGE_DATA_REQUEST = 'FETCH_DETAIL_PAGE_DATA_REQUEST';
export const FETCH_DETAIL_PAGE_DATA_START = 'FETCH_DETAIL_PAGE_DATA_START';
export const FETCH_DETAIL_PAGE_DATA_SUCCESS = 'FETCH_DETAIL_PAGE_DATA_SUCCESS';
export const FETCH_DETAIL_PAGE_DATA_FAILURE = 'FETCH_DETAIL_PAGE_DATA_FAILURE';
export const SORT_DETAIL_PAGE_DATA = 'SORT_DETAIL_PAGE_DATA';
export const CHANGE_DETAIL_PAGE_PAGE = 'CHANGE_DETAIL_PAGE_PAGE';
export const CHANGE_DETAIL_PAGE_ROWS_PER_PAGE = 'CHANGE_DETAIL_PAGE_ROWS_PER_PAGE';

// Action creators
export const fetchDetailPageData = (pageType, apiEndpoint, payload) => ({
  type: FETCH_DETAIL_PAGE_DATA_REQUEST,
  payload: { pageType, apiEndpoint, ...payload }
});

export const sortDetailPageData = (columnId) => ({
  type: SORT_DETAIL_PAGE_DATA,
  payload: { columnId }
});

export const changeDetailPagePage = (page) => ({
  type: CHANGE_DETAIL_PAGE_PAGE,
  payload: { page }
});

export const changeDetailPageRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_DETAIL_PAGE_ROWS_PER_PAGE,
  payload: { rowsPerPage }
});